import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToasterService } from '../../../shared/services/toaster.service';
import { BusinessService } from '../../../shared/services/business.service';
import { BaseResponse } from '../../../models/response';

@Component({
  selector: 'app-subscription',
  templateUrl: './subscription.component.html',
  styleUrls: ['./subscription.component.scss']
})
export class SubscriptionComponent implements OnInit {

  subcribeForm: FormGroup;
  isSubmitted: boolean = false;
  sapphire: boolean = false;
  onyx: boolean = false;
  topaz: boolean = false;
  sapphireTenantDoamin: any;
  product: any = [];
  tenantList: any = [];
  constructor(
    private toaster: ToasterService,
    private fBuild: FormBuilder,
    private bs: BusinessService
  ) { }

  ngOnInit(): void {
    this.formInitialize();
    this.tenantList = [
      {key:'ginesys',value:'Ginesys'}
    ]
  }
  formInitialize() {
    this.subcribeForm = this.fBuild.group({
      pan: [null, [Validators.required]]

    })
  }
  get ef() { return this.subcribeForm.controls; }

  clearData() {
    this.subcribeForm.reset();
    this.sapphire = false;
    this.onyx = false;
    this.topaz = false;
  }

  search() {
    this.isSubmitted = true;
    if(this.product.length == 0) {
      this.toaster.showWarning('At least one product required');
      return;
    }
    if(this.sapphire && this.sapphireTenantDoamin == null) {
      this.toaster.showWarning('Tenant is required');
      return;
    }
    if(this.subcribeForm.valid){
      let model = {
        pan: this.subcribeForm.value.pan,
        products: this.product,
        sapphireTenant: this.sapphire?this.sapphireTenantDoamin: null
      }
      this.bs.subscribeData(model).subscribe((response: BaseResponse) => {
        if(response.response) {
          this.toaster.showSuccess(response.message);
        } else {
          this.toaster.showError(response.message)
        }
      }, (err) => {
        this.toaster.showError("Network Error");
      });

    }
  }

  setProduct() {
    this.product = [];
    if(this.sapphire) {
      this.product.push('SAPPHIRE');
    } else {
      this.remove(this.product, 'SAPPHIRE');
    }
    if(this.onyx) {
      this.product.push('ONYX');
    } else {
      this.remove(this.product, 'ONYX');
    }
    if(this.topaz) {
      this.product.push('TOPAZ');
    } else {
      this.remove(this.product, 'TOPAZ');
    }

  }

  remove(arrOriginal, elementToRemove){
    return arrOriginal.filter(function(el){return el !== elementToRemove});
  }


}
